import React from 'react';
import { IEditorProps } from './Editor';
import { MultipleEntityPickerEditor } from './MultipleEntityPickerEditor'


interface IGroupsPickerEditorProps extends IEditorProps {}
/**
 * A Groups Picker editor, which launches a picker dialog for groups.
 * 
 * It curates a list of groups by name.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function GroupsPickerEditor({ child, path, onChange }: IGroupsPickerEditorProps) {

  return (
    <MultipleEntityPickerEditor {...{ child, path, onChange }}/>
  );
}
